import React from 'react';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material';
import { OrderTable } from '../components/OrderList/OrderTable';
import { useNavigate } from 'react-router-dom';
import { ErrorSnackbar } from '../components/OrderList/ErrorSnackbar';
import { PageHeader } from '../components/OrderList/PageHeader';
import { useOrder } from '../context';

function OrderListContent() {
  const theme = useTheme();
  const navigate = useNavigate();
  const { orders, isLoading, error, handleCreate, handleCloseError } = useOrder();


  

  const handleView = (order:{id:string}) => {
    navigate(`/orders/${order.id}`);
  };

  return (
    <>
      <ErrorSnackbar error={error} onClose={handleCloseError} />
      <Box
        style={{
          background: theme.palette.background.paper,
          borderRadius: 16,
          padding: 32,
          boxShadow: '0 2px 8px 0 rgba(16,30,54,0.04)',
          maxWidth: '100%',
          margin: '0 auto',
       
        }}
      >
        <PageHeader
          onCreate={handleCreate}
          isLoading={isLoading}
          title={'Encomendas'}
          subtitle={'Visualize e gerencie as encomendas'}
        />
        <OrderTable
          orders={orders}
          isLoading={isLoading}
          onView={handleView}
        />
      </Box>
    </>
  );
}

export default function OrderListPage() {
  return <OrderListContent />;
}